module.exports = __webpack_public_path__ + "static/sauce_cover.3545344b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/sauce_cover.png
// module id = 1374
// module chunks = 35783957827783 226605119891641